import React, {
  useRef,
  useCallback,
  memo,
  useImperativeHandle,
} from 'react'
import { useAnimation } from 'framer-motion'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import {
  siteData as siteDataState
} from '../../store/dataStore'
import {
  windowSize as windowSizeState,
  selectedAward as selectedAwardState,
} from '../../store/uiStore'

import 'slick-carousel/slick/slick.css'
import Slider from 'react-slick'
import SliderButton from './SliderButton'

import {
  AwardsSliderContainer,
  AwardsSliderItem,
} from '../../styles/awardsStyles'

const AwardsSlider = React.forwardRef(({ awards }, ref) => {
  const windowSize = useRecoilValue(windowSizeState)
  const setSelectedAward = useSetRecoilState(selectedAwardState)
  let slider = useRef(null)

  const siteData = useRecoilValue(siteDataState)

  const sliderOptions = {
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const handleNext = useCallback(() => {
    slider.current.slickNext()
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  const awardsSliderVars = {
    hidden: {
      opacity: 0,
      x: '30%',
      transition: {
        duration: 1,
        delay: 0,
        ease: 'easeOut',
      },
    },
    visible: {
      opacity: 1,
      x: 0,
    },
  }

  const awardsSliderAnims = useAnimation(awardsSliderVars)

  useImperativeHandle(ref, () => ({
    playVisible() {
      awardsSliderAnims.start('visible')
    },
    playHidden() {
      awardsSliderAnims.start('hidden')
    },
  }))

  const handleAwardsModal = (id) => {
    setSelectedAward((last) => id)
  }

  return (
    <>
      <AwardsSliderContainer
        ref={ref}
        initial='hidden'
        animate={awardsSliderAnims}
        variants={awardsSliderVars}
        transition={{
          duration: 1.5,
          ease: 'easeOut',
          delay: 1.25,
        }}>
        <Slider ref={slider} {...sliderOptions}>
          {Object.entries(awards).map(([id, award]) => (
            <AwardsSliderItem key={award.id}>
              <div className='cover'>
                <div className='frame'>
                  <img src={award.image} alt={award.name} />
                </div>
              </div>
              <div
                className='info'
                dangerouslySetInnerHTML={{ __html: award.description }}
              />
              <button onClick={() => handleAwardsModal(award.id)} className="more">{siteData.language === 'es' ? 'Leer más' : 'Read more'}</button>
            </AwardsSliderItem>
          ))}
        </Slider>
        {awards.length > 2 && windowSize.width > 860 && (
          <SliderButton handleNext={handleNext} />
        )}
      </AwardsSliderContainer>
    </>
  )
})

export default memo(AwardsSlider)
